import InputSelect from "components/Form/InputSelect";
import { LayoutContext } from "context/LayoutContext";
import React, { useContext, useEffect, useState } from "react";
import AccordionTransaction from "./_components/accordion-trx";
import { getDetailKpiSales } from "apis/detail_kpi_sales";
import moment from "moment";
import InputDateRange from "components/Form/InputDateRange/v1";
import { useParams } from "react-router-dom";
import InputMultipleSelect from "components/Form/InputMultipleSelect";
import { getCustomers } from "apis/customers";
import Table from "components/Table";
import Widget from "components/widget/Widget";
import { MdAttachMoney } from "react-icons/md";

const Index = () => {
  const { setHeaderComponent } = useContext(LayoutContext);
  const [loading, setLoading] = useState(true);
  const [info, setInfo] = useState(null);
  const [dateRange, setDateRange] = useState({
    startDate: moment().startOf("month").toDate(),
    endDate: moment().endOf("month").toDate(),
    key: "selection",
  });
  const [idCustomer, setIdCustomer] = useState(null);
  const { id } = useParams();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => setHeaderComponent([]), []);

  useEffect(() => {
    (async () => {
      try {
        let query = `?start_date=${moment(dateRange.startDate).format(
          "YYYY-MM-DD"
        )}&end_date=${moment(dateRange.endDate).format("YYYY-MM-DD")}`;

        if (idCustomer) {
          query += `&id_customer=${idCustomer}`;
        }

        const resp = await getDetailKpiSales(
          {
            id,
          },
          query
        );

        setInfo(resp);
      } catch (error) {
        console.error("Error when fetch : ", error);
      } finally {
        setTimeout(() => {
          setLoading(false);
        }, 700);
      }
    })();
  }, [id, dateRange.startDate, dateRange.endDate, idCustomer]);

  return (
    <>
      <div className="mt-6 flex items-end justify-end gap-4">
        <div className="w-1/5">
          {loading ? (
            <div class="h-12 w-full animate-pulse rounded-full bg-gray-200" />
          ) : (
            <InputMultipleSelect
              fetchList={getCustomers}
              rounded
              keyLabel="customer_name"
              keyValue="id_customer"
              label="Pilih pelanggan"
              value={idCustomer}
              onChange={(e) => {
                setIdCustomer(e);
              }}
            />
          )}
        </div>
        <div className="w-1/5">
          {loading ? (
            <div class="h-12 w-full animate-pulse rounded-full bg-gray-200" />
          ) : (
            <InputDateRange onChange={setDateRange} value={dateRange} />
          )}
        </div>
      </div>
      {loading ? (
        <div class="my-6 h-40 w-full animate-pulse rounded-xl bg-gray-200" />
      ) : (
        <div className="mt-6 rounded-xl bg-white p-6 shadow-sm">
          <div className="flex items-start justify-between">
            <div className="flex w-full items-start gap-6">
              {/* <div className="relative h-24 w-24">
              <div className="absolute inset-0">
                <svg className="h-full w-full" viewBox="0 0 100 100">
                  <circle
                    cx="50"
                    cy="50"
                    r="40"
                    fill="none"
                    stroke="#e5e7eb"
                    strokeWidth="12"
                  />
                  <circle
                    cx="50"
                    cy="50"
                    r="40"
                    fill="none"
                    stroke="#84cc16"
                    strokeWidth="12"
                    strokeDasharray="251.2"
                    strokeDashoffset="150.72"
                    transform="rotate(-90 50 50)"
                  />
                </svg>
              </div>
              <span className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform text-xs font-bold sm:text-lg">
                40%
              </span>
            </div> */}

              <div className="w-full">
                <div className="text-sm text-gray-600">
                  {info?.email || "-"}
                </div>
                <h1 className="mt-1 text-xl font-semibold">
                  {info?.sales_name}
                </h1>
                <div className="mt-1 text-sm text-gray-600">
                  {info?.phone || "-"}
                </div>

                <div className="mt-3 space-y-1">
                  <div className="text-sm">
                    <span className="text-gray-600">Periode: </span>
                    <span>
                      {moment(dateRange.startDate).format("DD MMMM YYYY")} -{" "}
                      {moment(dateRange.endDate).format("DD MMMM YYYY")}
                    </span>
                  </div>
                </div>
                <div className="mt-4 w-fit">
                  <Widget
                    icon={<MdAttachMoney className="h-7 w-7" />}
                    title="Total Kas belum Setor"
                    className="border pr-6"
                    subtitle={new Intl.NumberFormat("id-ID", {
                      style: "currency",
                      currency: "IDR",
                    }).format(info?.total_kas_not_deposited ?? 0)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {loading ? (
        <div class="h-40 w-full animate-pulse rounded-xl bg-gray-200" />
      ) : (
        <>
          <h2 className="my-4 text-lg font-semibold">
            Produk yang Sedang Dibawa
          </h2>
          <div className="flex flex-col gap-2">
            <div className="flex items-center gap-6 rounded-xl bg-white p-6 shadow-sm">
              <Table
                columnsData={[
                  {
                    accessorKey: "product_name",
                    cell: (info) => info.getValue(),
                    header: "Nama Produk",
                  },
                  {
                    accessorKey: "total_qty",
                    cell: (info) => info.getValue(),
                    header: "Total Qty",
                  },
                ]}
                tableData={info?.product_not_unloaded}
                currentPage={1}
                perPage={10}
                pageCount={info?.product_not_unloaded?.length}
                hidePagination
              />
            </div>
          </div>
        </>
      )}
      {loading ? (
        <div class="h-40 w-full animate-pulse rounded-xl bg-gray-200" />
      ) : (
        <>
          <h2 className="my-4 text-lg font-semibold">List Aktivitas</h2>
          <div className="flex flex-col gap-2">
            {info?.list_activity?.map((act) => (
              <div
                className="rounded-xl bg-white p-6 shadow-sm"
                key={act.activity_date}
              >
                <div className="mb-6 flex items-start justify-between">
                  <div>
                    <h2 className="text-xl font-bold">
                      {moment(act.activity_date).format("DD MMMM YYYY")}
                    </h2>
                  </div>
                </div>

                <div className="border-t pt-4">
                  <AccordionTransaction data={act.data} />
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </>
  );
};

export default Index;
